import React from 'react';
import metrics from '../config/impactMetrics.js';

function ImpactMetrics() {
    try {
        // metrics imported from centralized config

        return (
            <section className="min-h-screen bg-gray-900 text-white relative overflow-hidden" data-name="impact-metrics">
                <div className="container mx-auto px-4 py-16">
                    <div className="max-w-6xl mx-auto">
                        <div className="bg-gray-800/50 rounded-xl p-8 backdrop-blur-sm mb-20">
                            <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
                                {metrics.map((metric, index) => (
                                    <div key={index} className="text-center" data-name={`metric-${index}`}>
                                        <div className="text-4xl font-bold text-green-400 mb-2">{metric.value}</div>
                                        <div className="text-xl font-semibold mb-2">{metric.label}</div>
                                        <div className="text-gray-400 text-sm">{metric.description}</div>
                                        <div className="mt-4">
                                            <i className={`fas ${metric.icon} text-2xl text-green-400`}></i>
                                        </div>
                                    </div>
                                ))}
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        );
    } catch (error) {
        console.error('ImpactMetrics error:', error);
        reportError(error);
        return null;
    }
}

window.ImpactMetrics = ImpactMetrics;

export default ImpactMetrics;
